import * as Yup from 'yup'

const exclusiveSellerSchema = Yup.object().shape({
  username: Yup.string()
    .min(2, 'At least 2 characters')
    .required('Required'),

  name: Yup.string()
    .min(2, 'At least 2 characters')
    .required('Required'),

  gender: Yup.string()
    .required('Required'),

  referrer: Yup.string()
    .required('Required'),

  birthday: Yup.string()
    .required('Required'),

  email: Yup.string()
    .min(2, 'At least 2 characters')
    .email('Invalid email')
    .required('Required'),

  mobile: Yup.string()
    .min(10, 'At least 10 digits')
    .matches(/^(^62)(\d{3,4}-?){2}\d{3,4}$/, 'Please input a valid mobile number, starting with 62')
    .required('Required'),

  seller_type: Yup.string()
    .required('Required'),

  contract_id: Yup.string()
    .required('Required'),

  street_address: Yup.string()
    .min(5, 'At least 5 characters')
    .required('Required'),

  kelurahan: Yup.string()
    .min(5, 'At least 5 characters')
    .required('Required'),

  kecamatan: Yup.string()
    .min(5, 'At least 5 characters')
    .required('Required'),

  kota: Yup.string()
    .min(2, 'At least 2 characters')
    .required('Required'),

  provinsi: Yup.string()
    .min(5, 'At least 5 characters')
    .required('Required'),

  kode_pos: Yup.string()
    .required('Required')
    .matches(/^\d{5}(?:[-\s]\d{4})?$/, 'Invalid postal code')
    .min(5, 'At least 5 digits'),

  bank: Yup.string()
    .required('Required'),

  bank_branch: Yup.string()
    .required('Required'),

  account_number: Yup.string()
    .required('Required'),

  account_name: Yup.string()
    .required('Required')
})

export default exclusiveSellerSchema
